import { createSelector } from "reselect";

export interface State{
  token?: string;
  error: false;
  loading: false;
}

const SET_TOKEN = "SET_TOKEN";
const SET_ERROR = "SET_ERROR";
const SET_LOADING = "SET_LOADING";
export const TYPES = {
  SET_TOKEN,
  SET_ERROR,
  SET_LOADING,
};
const initialState: State = {
  error: false,
  loading: false,
};

const setToken = (payload) => ({ type: SET_TOKEN, payload });
const setError = (payload) => ({ type: SET_ERROR, payload });
const setLoading = (payload) => ({ type: SET_LOADING, payload });

export const Actions = {
  setToken,
  setError,
  setLoading,
};
export const Selectors = {
  isAuthenticated: createSelector<State, State, boolean>(s => s, s => !!s.token),
};

export const reducer = (state = initialState, action) => {
  switch (action.type){
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        token: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        token: action.payload,
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/store/reducer.ts